import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../libs'
import {
  WithdrawalGroup,
  WithdrawalGroupRequest,
  WithdrawalGroupResponse,
} from './types'

export const withdrawalGroupsListMounted = createEvent<WithdrawalGroupRequest>()

export const getWithdrawalGroups = fx<
  WithdrawalGroupRequest,
  WithdrawalGroupResponse
>({
  method: 'GET',
  url: `/withdrawal_group`,
})

export const $withdrawalGroups = restore<WithdrawalGroup[]>(
  getWithdrawalGroups.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfWithdrawalGroups = restore(
  getWithdrawalGroups.doneData.map((a) => a.body.total),
  0,
)
export const deleteWithdrawalGroupEvent = createEvent<number>()
export const deleteWithdrawalGroup = fx<WithdrawalGroup, WithdrawalGroup>({
  method: 'DELETE',
  url: '/withdrawal_group/',
})

sample({
  // @ts-ignore
  clock: withdrawalGroupsListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    if (orderBy === 'transactionId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    // if (filters) {
    //   //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
    //   let newObj = Object.keys(filters).reduce((accumulator, key) => {
    //     if (filters[key as keyof typeof filters] != null) {
    //       accumulator[key as keyof typeof filters] =
    //         key === 'country'
    //           ? filters[key as keyof typeof filters]
    //           : `${filters[key as keyof typeof filters]}`
    //     }
    //
    //     return accumulator
    //   }, {} as any)
    //
    //   if (!isAllElementsOfSearchTextNotExist(searchText)) {
    //     newObj = { ...newObj, ...mapSearchText(searchText) }
    //   }
    //
    //   if (Object.keys(newObj).length) {
    //     // @ts-ignore
    //     query['where'] = `${JSON.stringify(newObj)}`
    //   }
    // }

    return {
      query,
    }
  },
  target: getWithdrawalGroups,
})

sample({
  clock: deleteWithdrawalGroupEvent,
  fn: (id) => {
    return {
      url: `/withdrawal_group/${id}`,
    }
  },
  target: deleteWithdrawalGroup,
})

sample({
  // @ts-ignore
  clock: deleteWithdrawalGroup.doneData,
  fn: (doneData) => doneData.body,
  target: getWithdrawalGroups,
})
